import { useQuery } from '@apollo/client';
import { GetCustomRoleByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';

type Props = {
  customRoleId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ customRoleId }) => {
  if (!customRoleId) {
    throw new Error('Missing customRoleId param');
  }
  const { data } = useQuery(GetCustomRoleByIdDocument, {
    variables: {
      Id: customRoleId,
    },
  });

  return <>{data?.custom_role?.[0]?.RoleName || ''}</>;
};

export default Breadcrumb;
